// extracted by mini-css-extract-plugin
module.exports = {"start--btn":"style_start--btn__2L8VD","btn--not-allowed":"style_btn--not-allowed__3dyMw","btn--slider":"style_btn--slider__B23pl","preview":"style_preview__12PgS"};